import * as i0 from '@angular/core';
import * as i1 from './datepicker.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from './datepicker.component';
import * as i5 from './datepicker-inner.component';
import * as i6 from './daypicker.component';
import * as i7 from './monthpicker.component';
import * as i8 from './yearpicker.component';
export const DatepickerModuleNgFactory:i0.NgModuleFactory<i1.DatepickerModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.DatePickerComponent = (<any>(null as any));
var _decl0_33:i5.DatePickerInnerComponent = (<any>(null as any));
var _decl0_34:i6.DayPickerComponent = (<any>(null as any));
var _decl0_35:i7.MonthPickerComponent = (<any>(null as any));
var _decl0_36:i8.YearPickerComponent = (<any>(null as any));
var _decl0_37:i2.AsyncPipe = (<any>(null as any));
var _decl0_38:i2.UpperCasePipe = (<any>(null as any));
var _decl0_39:i2.LowerCasePipe = (<any>(null as any));
var _decl0_40:i2.JsonPipe = (<any>(null as any));
var _decl0_41:i2.SlicePipe = (<any>(null as any));
var _decl0_42:i2.DecimalPipe = (<any>(null as any));
var _decl0_43:i2.PercentPipe = (<any>(null as any));
var _decl0_44:i2.TitleCasePipe = (<any>(null as any));
var _decl0_45:i2.CurrencyPipe = (<any>(null as any));
var _decl0_46:i2.DatePipe = (<any>(null as any));
var _decl0_47:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_48:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_49:i2.CommonModule = (<any>(null as any));
var _decl0_50:i3.FormsModule = (<any>(null as any));
var _decl0_51:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_52:i0.ElementRef<any> = (<any>(null as any));
function _View_DatePickerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_DatePickerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_32.config.locale;
  currVal_0;
  const currVal_1:any = _decl0_32.datepickerMode;
  currVal_1;
  const currVal_2:any = _decl0_32.startingDay;
  currVal_2;
  const currVal_3:any = _decl0_32.yearRange;
  currVal_3;
  const currVal_4:any = _decl0_32.minDate;
  currVal_4;
  const currVal_5:any = _decl0_32.maxDate;
  currVal_5;
  const currVal_6:any = _decl0_32.minMode;
  currVal_6;
  const currVal_7:any = _decl0_32.maxMode;
  currVal_7;
  const currVal_8:any = _decl0_32.showWeeks;
  currVal_8;
  const currVal_9:any = _decl0_32.formatDay;
  currVal_9;
  const currVal_10:any = _decl0_32.formatMonth;
  currVal_10;
  const currVal_11:any = _decl0_32.formatYear;
  currVal_11;
  const currVal_12:any = _decl0_32.formatDayHeader;
  currVal_12;
  const currVal_13:any = _decl0_32.formatDayTitle;
  currVal_13;
  const currVal_14:any = _decl0_32.formatMonthTitle;
  currVal_14;
  const currVal_15:any = _decl0_32.onlyCurrentMonth;
  currVal_15;
  const currVal_16:any = _decl0_32.shortcutPropagation;
  currVal_16;
  const currVal_17:any = _decl0_32.customClass;
  currVal_17;
  const currVal_18:any = _decl0_32.monthColLimit;
  currVal_18;
  const currVal_19:any = _decl0_32.yearColLimit;
  currVal_19;
  const currVal_20:any = _decl0_32.dateDisabled;
  currVal_20;
  const currVal_21:any = _decl0_32.dayDisabled;
  currVal_21;
  const currVal_22:any = _decl0_32.initDate;
  currVal_22;
  const currVal_23:any = _decl0_32.activeDate;
  currVal_23;
  const pd_24:any = ((<any>_decl0_32.onUpdate(_any)) !== false);
  const pd_25:any = ((<any>_decl0_32.onSelectionDone(_any)) !== false);
  const pd_26:any = ((<any>_decl0_32.onActiveDateChange(_any)) !== false);
}
function _View_DatePickerInnerComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_DatePickerInnerComponent_2_1():void {
  if (_decl0_33.datepickerMode) { var _any:any = (null as any); }
}
function _View_DatePickerInnerComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_33.datepickerMode;
  currVal_0;
}
function _View_DayPickerComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_DayPickerComponent_3_2():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && !_decl0_34.isBs4)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_34.datePicker.move((0 - 1))) !== false);
  }
}
function _View_DayPickerComponent_3_3():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && _decl0_34.isBs4)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_34.datePicker.move((0 - 1))) !== false);
  }
}
function _View_DayPickerComponent_3_4():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && !_decl0_34.isBs4)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_34.datePicker.move(1)) !== false);
  }
}
function _View_DayPickerComponent_3_5():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && _decl0_34.isBs4)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_34.datePicker.move(1)) !== false);
  }
}
function _View_DayPickerComponent_3_6():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && _decl0_34.datePicker.showWeeks)) { var _any:any = (null as any); }
}
function _View_DayPickerComponent_3_7():void {
  if ((_decl0_34.datePicker.datepickerMode === 'day')) {
    var _any:any = (null as any);
    const currVal_0:any = _any.abbr;
    currVal_0;
  }
}
function _View_DayPickerComponent_3_10():void {
  if ((((_decl0_34.datePicker.datepickerMode === 'day') && !((_decl0_34.datePicker.onlyCurrentMonth && _any[0].secondary) && _any[6].secondary)) && _decl0_34.datePicker.showWeeks)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_34.weekNumbers[_any];
    currVal_0;
  }
}
function _View_DayPickerComponent_3_12():void {
  if ((((_decl0_34.datePicker.datepickerMode === 'day') && !((_decl0_34.datePicker.onlyCurrentMonth && _any[0].secondary) && _any[6].secondary)) && !(_decl0_34.datePicker.onlyCurrentMonth && _any.secondary))) {
    var _any:any = (null as any);
    const currVal_0:any = i0.ɵinlineInterpolate(1,'btn btn-sm ',_any.customClass,'');
    currVal_0;
    const currVal_1:any = {'btn-secondary':((_decl0_34.isBs4 && !_any.selected) && !_decl0_34.datePicker.isActive(_any)),
        'btn-info':_any.selected,disabled:_any.disabled,active:(!_decl0_34.isBs4 && _decl0_34.datePicker.isActive(_any)),
        'btn-default':!_decl0_34.isBs4};
    currVal_1;
    const currVal_2:any = _any.disabled;
    currVal_2;
    const currVal_3:any = {'text-muted':(_any.secondary || _any.current),'text-info':(!_decl0_34.isBs4 && _any.current)};
    currVal_3;
    const currVal_4:any = _any.label;
    currVal_4;
    const pd_5:any = ((<any>_decl0_34.datePicker.select(_any.date)) !== false);
  }
}
function _View_DayPickerComponent_3_11():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && !((_decl0_34.datePicker.onlyCurrentMonth && _any[0].secondary) && _any[6].secondary))) {
    var _any:any = (null as any);
    const currVal_0:any = _any.uid;
    currVal_0;
    const currVal_1:any = !(_decl0_34.datePicker.onlyCurrentMonth && _any.secondary);
    currVal_1;
  }
}
function _View_DayPickerComponent_3_9():void {
  if (((_decl0_34.datePicker.datepickerMode === 'day') && !((_decl0_34.datePicker.onlyCurrentMonth && _any[0].secondary) && _any[6].secondary))) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_34.datePicker.showWeeks;
    currVal_0;
    const currVal_1:any = _any;
    currVal_1;
  }
}
function _View_DayPickerComponent_3_8():void {
  if ((_decl0_34.datePicker.datepickerMode === 'day')) {
    var _any:any = (null as any);
    const currVal_0:any = !((_decl0_34.datePicker.onlyCurrentMonth && _any[0].secondary) && _any[6].secondary);
    currVal_0;
  }
}
function _View_DayPickerComponent_3_1():void {
  if ((_decl0_34.datePicker.datepickerMode === 'day')) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_34.datePicker.uniqueId + '-title');
    currVal_0;
    const currVal_1:any = !_decl0_34.isBs4;
    currVal_1;
    const currVal_2:any = _decl0_34.isBs4;
    currVal_2;
    const currVal_3:any = (5 + (_decl0_34.datePicker.showWeeks? 1: 0));
    currVal_3;
    const currVal_4:any = 'btn btn-default btn-secondary btn-sm';
    currVal_4;
    const currVal_5:any = {disabled:(_decl0_34.datePicker.datepickerMode === _decl0_34.datePicker.maxMode)};
    currVal_5;
    const currVal_6:any = (_decl0_34.datePicker.uniqueId + '-title');
    currVal_6;
    const currVal_7:any = (_decl0_34.datePicker.datepickerMode === _decl0_34.datePicker.maxMode);
    currVal_7;
    const currVal_8:any = _decl0_34.title;
    currVal_8;
    const currVal_9:any = !_decl0_34.isBs4;
    currVal_9;
    const currVal_10:any = _decl0_34.isBs4;
    currVal_10;
    const currVal_11:any = _decl0_34.datePicker.showWeeks;
    currVal_11;
    const currVal_12:any = _decl0_34.labels;
    currVal_12;
    const currVal_13:any = _decl0_34.rows;
    currVal_13;
    const pd_14:any = ((<any>_decl0_34.datePicker.toggleMode(0)) !== false);
  }
}
function _View_DayPickerComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_34.datePicker.datepickerMode === 'day');
  currVal_0;
}
function _View_MonthPickerComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_MonthPickerComponent_4_3():void {
  if ((_decl0_35.datePicker.datepickerMode === 'month')) {
    var _any:any = (null as any);
    const currVal_0:any = 'text-center';
    currVal_0;
    const currVal_1:any = _any.customClass;
    currVal_1;
    const currVal_2:any = _any.uid;
    currVal_2;
    const currVal_3:any = 'btn btn-default';
    currVal_3;
    const currVal_4:any = {'btn-link':((_decl0_35.isBs4 && !_any.selected) && !_decl0_35.datePicker.isActive(_any)),
        'btn-info':(_any.selected || ((_decl0_35.isBs4 && !_any.selected) && _decl0_35.datePicker.isActive(_any))),
        disabled:_any.disabled,active:(!_decl0_35.isBs4 && _decl0_35.datePicker.isActive(_any))};
    currVal_4;
    const currVal_5:any = _any.disabled;
    currVal_5;
    const currVal_6:any = {'text-success':(_decl0_35.isBs4 && _any.current),'text-info':(!_decl0_35.isBs4 && _any.current)};
    currVal_6;
    const currVal_7:any = _any.label;
    currVal_7;
    const pd_8:any = ((<any>_decl0_35.datePicker.select(_any.date)) !== false);
  }
}
function _View_MonthPickerComponent_4_2():void {
  if ((_decl0_35.datePicker.datepickerMode === 'month')) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
  }
}
function _View_MonthPickerComponent_4_1():void {
  if ((_decl0_35.datePicker.datepickerMode === 'month')) {
    var _any:any = (null as any);
    const currVal_0:any = (((_decl0_35.datePicker.monthColLimit - 2) <= 0)? 1: (_decl0_35.datePicker.monthColLimit - 2));
    currVal_0;
    const currVal_1:any = 'btn btn-default btn-sm';
    currVal_1;
    const currVal_2:any = {disabled:(_decl0_35.datePicker.datepickerMode === _decl0_35.maxMode)};
    currVal_2;
    const currVal_3:any = (_decl0_35.datePicker.uniqueId + '-title');
    currVal_3;
    const currVal_4:any = (_decl0_35.datePicker.datepickerMode === _decl0_35.maxMode);
    currVal_4;
    const currVal_5:any = _decl0_35.title;
    currVal_5;
    const currVal_6:any = _decl0_35.rows;
    currVal_6;
    const pd_7:any = ((<any>_decl0_35.datePicker.move((0 - 1))) !== false);
    const pd_8:any = ((<any>_decl0_35.datePicker.toggleMode(0)) !== false);
    const pd_9:any = ((<any>_decl0_35.datePicker.move(1)) !== false);
  }
}
function _View_MonthPickerComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_35.datePicker.datepickerMode === 'month');
  currVal_0;
}
function _View_YearPickerComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_YearPickerComponent_5_3():void {
  if ((_decl0_36.datePicker.datepickerMode === 'year')) {
    var _any:any = (null as any);
    const currVal_0:any = _any.uid;
    currVal_0;
    const currVal_1:any = 'btn btn-default';
    currVal_1;
    const currVal_2:any = {'btn-link':((_decl0_36.isBs4 && !_any.selected) && !_decl0_36.datePicker.isActive(_any)),
        'btn-info':(_any.selected || ((_decl0_36.isBs4 && !_any.selected) && _decl0_36.datePicker.isActive(_any))),
        disabled:_any.disabled,active:(!_decl0_36.isBs4 && _decl0_36.datePicker.isActive(_any))};
    currVal_2;
    const currVal_3:any = _any.disabled;
    currVal_3;
    const currVal_4:any = {'text-success':(_decl0_36.isBs4 && _any.current),'text-info':(!_decl0_36.isBs4 && _any.current)};
    currVal_4;
    const currVal_5:any = _any.label;
    currVal_5;
    const pd_6:any = ((<any>_decl0_36.datePicker.select(_any.date)) !== false);
  }
}
function _View_YearPickerComponent_5_2():void {
  if ((_decl0_36.datePicker.datepickerMode === 'year')) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
  }
}
function _View_YearPickerComponent_5_1():void {
  if ((_decl0_36.datePicker.datepickerMode === 'year')) {
    var _any:any = (null as any);
    const currVal_0:any = (((_decl0_36.datePicker.yearColLimit - 2) <= 0)? 1: (_decl0_36.datePicker.yearColLimit - 2));
    currVal_0;
    const currVal_1:any = 'btn btn-default btn-sm';
    currVal_1;
    const currVal_2:any = {disabled:(_decl0_36.datePicker.datepickerMode === _decl0_36.datePicker.maxMode)};
    currVal_2;
    const currVal_3:any = (_decl0_36.datePicker.uniqueId + '-title');
    currVal_3;
    const currVal_4:any = (_decl0_36.datePicker.datepickerMode === _decl0_36.datePicker.maxMode);
    currVal_4;
    const currVal_5:any = _decl0_36.title;
    currVal_5;
    const currVal_6:any = _decl0_36.rows;
    currVal_6;
    const pd_7:any = ((<any>_decl0_36.datePicker.move((0 - 1))) !== false);
    const pd_8:any = ((<any>_decl0_36.datePicker.toggleMode(0)) !== false);
    const pd_9:any = ((<any>_decl0_36.datePicker.move(1)) !== false);
  }
}
function _View_YearPickerComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_36.datePicker.datepickerMode === 'year');
  currVal_0;
}
